<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-01 09:43:39
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-04-02 09:58:32
 * @FilePath: \minipro-manger\src\views\WeatherAlert\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE   
-->
<template>
  <div>
    <el-card class="box-card" style="height:850px">
      <div slot="header">
        <div class="headerCardBox2">
          <div style="width:400px">
            作物选择：
            <el-select v-model="value" placeholder="请选择" size="mini" @change="palnchange">
              <el-option label="冬小麦" value="010301"></el-option>
              <el-option label="一季稻" value="010004"></el-option>
              <el-option label="油菜" value="010603"></el-option>
            </el-select>
          </div>
          <div style="width:400px">
            发育期：
            <el-select v-model="growCode" placeholder="请选择" size="mini">
              <el-option :label="item.name" :value="item.code" v-for="item in  growList"></el-option>
            </el-select>
          </div>
        </div>
        <div class="seachBtn">
          <el-button type="primary" size="mini" @click="getTableData">查询</el-button>
          <el-button type="primary" size="mini">重置</el-button>
        </div>
      </div>
      <div>
        <div class="adddBtnBox">
          <el-button type="primary" @click="addPopShow=true">添加</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%" :border="true" height="650" stripe>
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column prop="releaseTime" label="发布时间"></el-table-column>
          <el-table-column prop="abstracts" label="摘要"></el-table-column>
          <el-table-column prop="weatherAnalysis" label="天气"></el-table-column>
          <el-table-column prop="expertGuidance" label="指导"></el-table-column>
          <el-table-column prop="agriculturalAdvice" label="建议"></el-table-column>

          <el-table-column prop="address" label="操作" width="250">
            <template slot-scope="scope">
              <el-button size="mini" @click="editMsg(scope.row)">修改</el-button>
              <el-popconfirm title="这是一段内容确定删除吗？" @confirm="mydelete(scope.row.id)">
                <el-button size="mini" type="danger" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <el-pagination background layout="prev, pager, next" :total="1"></el-pagination> -->
    </el-card>
    <el-dialog title="信息新增" :visible.sync="addPopShow" width="30%">
      <div class="inpTbox">
        <div>作物种类</div>
        <div>
          <el-select v-model="addData.cropCode" placeholder="请选择" size="mini" @change="palnchange">
            <el-option label="冬小麦" value="010301"></el-option>
            <el-option label="一季稻" value="010004"></el-option>
            <el-option label="油菜" value="010603"></el-option>
          </el-select>
        </div>
      </div>
      <div class="inpTbox">
        <div>发育期</div>
        <div>
          <el-select v-model="addData.growthCode" placeholder="请选择" size="mini">
            <el-option :label="item.name" :value="item.code" v-for="item in  growList2"></el-option>
          </el-select>
        </div>
      </div>
      <el-input placeholder="请输入内容" v-model="addData.title" style="margin-top:10px">
        <template slot="prepend">标题</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="addData.abstracts" style="margin-top:10px">
        <template slot="prepend">摘要</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="addData.weatherAnalysis" style="margin-top:10px">
        <template slot="prepend">天气</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="addData.agriculturalAdvice" style="margin-top:10px">
        <template slot="prepend">建议</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="addData.expertGuidance" style="margin-top:10px">
        <template slot="prepend">指导</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="addData.images" style="margin-top:10px">
        <template slot="prepend">图片</template>
      </el-input>

      <el-input placeholder="请输入内容" v-model="addData.remarks" style="margin-top:10px">
        <template slot="prepend">备注</template>
      </el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addPopShow = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="信息修改" :visible.sync="editPopShow" width="30%">
      <div class="inpTbox">
        <div>作物种类</div>
        <div>
          <el-select v-model="editData.cropCode" placeholder="请选择" size="mini" @change="palnchange">
            <el-option label="冬小麦" value="010301"></el-option>
            <el-option label="一季稻" value="010004"></el-option>
            <el-option label="油菜" value="010603"></el-option>
          </el-select>
        </div>
      </div>
      <div class="inpTbox">
        <div>发育期</div>
        <div>
          <el-select v-model="editData.growthCode" placeholder="请选择" size="mini">
            <el-option :label="item.name" :value="item.code" v-for="item in  growList2"></el-option>
          </el-select>
        </div>
      </div>
      <el-input placeholder="请输入内容" v-model="editData.title" style="margin-top:10px">
        <template slot="prepend">标题</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="editData.abstracts" style="margin-top:10px">
        <template slot="prepend">摘要</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="editData.weatherAnalysis" style="margin-top:10px">
        <template slot="prepend">天气</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="editData.agriculturalAdvice" style="margin-top:10px">
        <template slot="prepend">建议</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="editData.expertGuidance" style="margin-top:10px">
        <template slot="prepend">指导</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="editData.images" style="margin-top:10px">
        <template slot="prepend">图片</template>
      </el-input>

      <el-input placeholder="请输入内容" v-model="editData.remarks" style="margin-top:10px">
        <template slot="prepend">备注</template>
      </el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editPopShow = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      textarea: "",
      input1: "",
      tableData: [],
      addgrowCode: "",
      value: "010301",
      allData: [],
      growCode: "all",
      growList: [],
      growList2: [],
      dialogVisible: false,
      chooseData: {},
      addPopShow: false,
      editPopShow: false,
      addData: {
        cropCode: "",
        growthCode: "",
        title: "",
        abstracts: "",
        weatherAnalysis: "",
        agriculturalAdvice: "",
        expertGuidance: " ",
        images: "",
        releaseTime: "",
        remarks: ""
      },
      editData: {}
    };
  },
  created() {
    this.getList();
    this.getTableData();
  },
  methods: {
    palnchange() {
      this.growCode = "all";
      this.getList();
    },
    getList() {
      this.axios({
        method: "get",
        url: `https://www.moodsci.com/chongzhouAPI/InterfaceServices/CropService/queryGrowthList?cropCode=${this.value}`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        // console.log(res.data.data);
        this.growList = res.data.data;
        this.growList2 = JSON.parse(JSON.stringify(res.data.data));
        this.growList.push({
          name: "全部",
          code: "all"
        });
        console.log(this.growList2);
        // this.tableData = res.data;
      });
    },
    mydelete(data) {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/crop/deleteCropGuidance",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          id: data
        }
      }).then(res => {
        // console.log(res.data);
        // this.tableData = res.data;
        this.$message({
          message: "删除成功",
          type: "success"
        });
        // this.addPopShow = false;
        this.getTableData();
      });
    },
    editMsg(data) {
      console.log(data);
      this.editData = data;
      this.editPopShow = true;
    },
    submitEdit() {
      this.editData.releaseTime = moment().format("YYYY-MM-DD HH:mm:ss");
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/crop/updateCropGuidance",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: this.editData
      }).then(res => {
        console.log(res.data);
        this.editPopShow = false;
        this.$message({
          message: "修改成功",
          type: "success"
        });
        this.getTableData();
        // this.tableData = res.data;
        // this.tableData = res.data[0];
        // this.allData = res.data;
      });
    },
    submitAdd() {
      this.addData.releaseTime = moment().format("YYYY-MM-DD HH:mm:ss");
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/crop/addCropGuidance",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: this.addData
      }).then(res => {
        // console.log(res.data);
        this.addPopShow = false;
        this.$message({
          message: "添加成功",
          type: "success"
        });
        this.getTableData();
        // this.tableData = res.data;
        // this.tableData = res.data[0];
        // this.allData = res.data;
      });
    },
    sendMsg(data) {
      console.log(data);
      this.chooseData = data;
      this.dialogVisible = true;
    },
    TypeChange() {
      //   this.tableData = this.allData[this.value];
    },
    getTableData() {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/crop/getCropGuidance",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          cropCode: this.value,
          growthCode: this.growCode
        }
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data;
        // this.tableData = res.data[0];
        // this.allData = res.data;
      });
    }
  }
};
</script>

<style>
.headerCardBox2 {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
}
.seachBtn {
  display: flex;
  justify-content: end;
  margin-top: 15px;
}
.adddBtnBox {
  height: 50px;
  float: right;
}
.inpTbox {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
</style>